export const ArrowDown = () => {
  return (
    <svg
      width="9"
      height="4"
      viewBox="0 0 9 4"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="image"
      aria-labelledby="downArrowIconTitle downArrowIconDesc"
    >
      <title id="downArrowIconTitle">Down Arrow Icon</title>
      <desc id="downArrowIconDesc">Down Arrow Icon</desc>
      <path d="M8.16675 0L4.16675 4L0.166748 0H8.16675Z" fill="#030302" />
    </svg>
  );
};
